
import { defineComponent, ref } from 'vue';
import { ComponentName } from '@/products/api/configuration/components/ComponentName';
import { DataType } from '@/products/api/configuration/application/DataType';
import { setupComponent } from '@/products/composables/setupComponent';

export default defineComponent({
  name: ComponentName.searchView,

  props: {
    instanceId: String,
  },

  setup(props) {
    const root = ref<HTMLElement>();

    const { componentName, isReady, store, routeData } = setupComponent(root, props.instanceId, [
      DataType.Products,
    ]);

    return {
      root,
      componentName,
      isReady,
      store,
      routeData,
    };
  },
});
